import React from 'react';
import { ImpactLevel } from '@/shared/types/api';
import { getImpactMeta } from '@/shared/lib/classificationMeta';
import { cn } from '@/shared/utils/cn';

interface ImpactBadgeProps {
  value?: ImpactLevel | string | null;
  isClassifying?: boolean;
}

/**
 * Impact on a red→emerald hue heat scale via severity tokens (dark-safe from a
 * single class set). Icon + label provide the non-color cue.
 */
export const ImpactBadge: React.FC<ImpactBadgeProps> = ({ value, isClassifying }) => {
  if (value == null && isClassifying) {
    return (
      <span
        className="sev sev-none animate-pulse"
        aria-busy="true"
        aria-label="Impact: classifying"
        title="Impact classification in progress"
      >
        Classifying…
      </span>
    );
  }

  const meta = getImpactMeta(value);
  const Icon = meta.icon;

  return (
    <span
      className={cn('sev', meta.sev)}
      title={`Impact: ${meta.label}`}
      aria-label={`Impact: ${meta.label}`}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {meta.label}
    </span>
  );
};
